import {captureException} from '@sentry/gatsby';

const initErrorLogging = () => {
  const captureError = async (error: any) => {
    try {
      console.warn(error); // Log error to console for clarification
      captureException(error);
    } catch (e) {
      console.warn('Logging to Sentry failed', e);
      window.onerror = null;
    }
  };

  window.onerror = (message, url, line, column, error) => captureError(error);
  window.onunhandledrejection = (event: any) => captureError(event.reason);
};

export default initErrorLogging;
